import { defineMessages } from 'react-intl';

export default defineMessages({
    addLocationButton: {
        id: 'wmic-pe-capability-gateway-common-ho-react.components.WMICHOCoverages.WMICHOContentsOffPremisesCov.WMICHOContentsOffPremisesCov.Add Location',
        defaultMessage: 'Add Location',
    },
    limit: {
        id: 'wmic-pe-capability-gateway-common-ho-react.components.WMICHOCoverages.WMICHOContentsOffPremisesCov.WMICHOContentsOffPremisesCov.Limit',
        defaultMessage: 'Limit',
    },
    location: {
        id: 'wmic-pe-capability-gateway-common-ho-react.components.WMICHOCoverages.WMICHOContentsOffPremisesCov.WMICHOContentsOffPremisesCov.Location',
        defaultMessage: 'Location',
    },
    oneLocationRequired: {
        id: 'wmic-pe-capability-gateway-common-ho-react.components.WMICHOCoverages.WMICHOContentsOffPremisesCov.WMICHOContentsOffPremisesCov.Minimum of one Location required',
        defaultMessage: 'Minimum of one Location required',
    },
});
